export var BuildingType;
(function (BuildingType) {
    BuildingType["ResidentialBuildings"] = "ResidentialBuildings";
    BuildingType["Hotel"] = "Hotel";
    BuildingType["AdministrativeBuildings"] = "AdministrativeBuildings";
    BuildingType["Hospital"] = "Hospital";
    BuildingType["EducationalInstitutions"] = "EducationalInstitutions";
    BuildingType["PreschoolEducationalInstitutions"] = "PreschoolEducationalInstitutions";
})(BuildingType || (BuildingType = {}));
export var RuBuildingTypeNamesMap = {
    ResidentialBuildings: 'Жилые здания',
    Hotel: 'Отель',
    AdministrativeBuildings: 'Административные здания',
    Hospital: 'Больница',
    EducationalInstitutions: 'Образовательные учреждения',
    PreschoolEducationalInstitutions: 'Дошкольные образовательные учреждения',
};
export var RuBuildingTypeSelectValues = [
    { label: 'Жилые здания', value: BuildingType.ResidentialBuildings },
    { label: 'Отель', value: BuildingType.Hotel },
    { label: 'Административные здания', value: BuildingType.AdministrativeBuildings },
    { label: 'Больница', value: BuildingType.Hospital },
    { label: 'Образовательные учреждения', value: BuildingType.EducationalInstitutions },
    {
        label: 'Дошкольные образовательные учреждения',
        value: BuildingType.PreschoolEducationalInstitutions,
    },
];
